import { Navigate, useParams } from "react-router-dom";
import { getProductBySlug } from "@/lib/catalog";

// /products/:slug → /products/:category/:slug for backward compatibility
export default function LegacyProductRedirect() {
  const { slug } = useParams();
  const product = getProductBySlug(slug);
  if (!product) return <Navigate to="/products" replace />;
  return <Navigate to={`/products/${product.category}/${product.slug}`} replace />;
}
